import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { Box, Toolbar, colors } from "@mui/material";
import TopBar from "../components/TopBar";
import { AgreementSyncCountProvider } from "../AgreementSyncCountContext";

const HomeLayout = () => {
  const [isOpen, setIsOpen] = useState(false);

  const getData = (data) => {
    setIsOpen(data);
  };

  // The provider wraps both halves on purpose: the Sidebar shows the Agreement Sync badge, and
  // the Outlet holds the screen whose actions clear it.
  return (
    <AgreementSyncCountProvider>
      <Box sx={{ display: "flex" }}>
        <TopBar isOpen={isOpen} />
        <Box>
          <Sidebar navOpen={getData} />
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            width: `calc(100% - ${"300px"})`,
            minHeight: "100vh",
            backgroundColor: colors.grey["100"],
          }}
        >
          <Toolbar />
          <Outlet />
        </Box>
      </Box>
    </AgreementSyncCountProvider>
  );
};

export default HomeLayout;
